class ReviewSlide extends HTMLElement {
  constructor() {
    super();
    this.elem = this.querySelector(".review__list");
    this.btnPrev = this.querySelectorAll(".js-slider-arrows__prev");
    this.btnNext = this.querySelectorAll(".js-slider-arrows__next");
    if (this.elem) {
      this.flkty = new Flickity( this.elem, {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: true,
        pageDots: false
      });
    
      this.btnNext.forEach(item => {
        item.addEventListener("click", () => {
          this.flkty.next();
        })
      })
    
      this.btnPrev.forEach(item => {
        item.addEventListener("click", () => {
          this.flkty.previous();
        })
      })
    }
  }
}
customElements.define("review-slide", ReviewSlide)